import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const loginFlag = localStorage.getItem('loginFlag') === 'true';

    if (!loginFlag) {
      // Not logged in → allow access to page
      return true;
    } else {
      // Logged in → redirect to /home or profile
      return this.router.parseUrl('/home');
    }
  }
}
